/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */


import {Component, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../destroyable.component';
import {ProfileType} from '../../shared/employees/contract/contract.interfaces';
import {Contract} from '../../shared/employees/employees.model';
import {UPDATE_PERSONAL_INFO_WORKFLOW} from '../../shared/workflow/workflow-v2.service';
import {ESSService} from '../employee-self.service';
import {ProfileMode} from '../../app.constants';

@Component({
  selector: 'ess-personal-info',
  templateUrl: './personal-info.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PersonalInfoComponent extends Destroyable implements OnInit {

  public static ACCESS_NAME: string = 'ESSPersonalInfo';

  public essProfileType: ProfileType = ProfileType.ESS;
  public profileMode = ProfileMode.ESS;
  public selectedContract: Contract;

  @ViewChild('fieldComponent', {read: ViewContainerRef, static: true})
  private fieldComponent: ViewContainerRef;

  public workflowName = UPDATE_PERSONAL_INFO_WORKFLOW;

  constructor(public essService: ESSService) {
    super();
  }

  public ngOnInit() {
    this.essService.currentContract
      .pipe(
        takeUntil(this.componentDestroyed$),
        tap((contract: Contract) => this.selectedContract = contract)
      )
      .subscribe();
  }

}
